export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'

export const SET_ITEMS_CART = 'SET_ITEMS_CART'
export const ADD_ITEM_CART = 'ADD_ITEM_CART'
export const GET_TOTAL_PRICE = 'GET_TOTAL_PRICE'
export const DELETE_ITEM_CART = 'DELETE_ITEM_CART'
export const INCREASE_ITEM_CART = 'INCREASE_ITEM_CART'
export const REDUCE_ITEM_CART = 'REDUCE_ITEM_CART'
